import './styles.scss'
import {IWidgetResponse} from '../../../api/Base/Base.types'
import NumberUtils from "../../../utils/number.utils";
import WidgetNivoBase from "../Widget.nivo.base";
import {
    IShipmentCountByDestinationRegion
} from "../../../api/ShipmentCountByDestinationRegion/ShipmentCountByDestinationRegion.types";

interface Props {
    data?: IWidgetResponse<IShipmentCountByDestinationRegion>
}

function ShipmentCountByDestinationRegion({data}: Props) {
    function getData() {
        if (data) {
            return data.data
                .sort((a, b) => b.containerCount - a.containerCount)
                .slice(0, 20)
                .map(d => ({destinationRegion: d.destinationRegion, containerCount: d.containerCount})
                );
        }
    }

    return (
        <div className="top-transits-in-lane">
            <WidgetNivoBase.Bar
                title="Shipments By Destination Region"
                data={getData()}
                keys={["containerCount"]}
                indexBy="destinationRegion"
                axisLeftName="# Containers"
                axisBottomName="Destination Region"
                axisBottomRotation={-45}
                formatValue={v => NumberUtils.toShortened(v, 2)}
                formatXAxis={v => v.slice(0, 3)}
                tooltip={(props) => {
                    const {indexValue, value, color} = props;
                    return (
                        <div style={{padding: 12, color, background: "#222222", borderRadius: 10}}>
                            <div>{indexValue}</div>
                            <strong>{NumberUtils.numberWithCommas(value)} Containers</strong>
                        </div>
                    )
                }}
            />
        </div>
    )
}

export default ShipmentCountByDestinationRegion;